import {connect} from 'react-redux';
import React from 'react';

import SaveProjectModalComponent from '../components/save-project-modal/save-project-modal.jsx';
import {
    saveStart,
    saveSuccess,
    saveFailure,
    getCloudProjectId,
    getCloudProjectName
} from '../reducers/cloud-project.js';
import {setProjectTitle} from '../reducers/project-title.js';

/*
 * Connects the naming dialog to the account state.
 *
 * The dialog owns the upload, so this container only supplies what the dialog
 * needs to decide between creating and updating:
 *   - no linked project yet -> create one, remember its id
 *   - already linked        -> update that same project (which is also how a
 *                              saved project gets renamed)
 *
 * The default name prefers the linked project's stored name so reopening the
 * dialog after a save shows what is actually on the server, and falls back to
 * the menu bar title for a project that has never been saved.
 */
const SaveProjectModal = props => (
    <SaveProjectModalComponent
        defaultName={props.savedName || props.defaultName}
        projectId={props.projectId}
        saveProjectSb3={props.saveProjectSb3}
        onCancel={props.onCancel}
        onSaveFailure={props.onSaveFailure}
        onSaveStart={props.onSaveStart}
        onSaveSuccess={props.onSaveSuccess}
        onSaved={props.onSaved}
    />
);

SaveProjectModal.propTypes = SaveProjectModalComponent.propTypes;

const mapStateToProps = state => ({
    projectId: getCloudProjectId(state.scratchGui.cloudProject),
    savedName: getCloudProjectName(state.scratchGui.cloudProject)
});

const mapDispatchToProps = dispatch => ({
    onSaveStart: () => dispatch(saveStart()),
    // Keep the menu bar title in sync with the saved name, so the editor and
    // the account agree on what the project is called.
    onSaveSuccess: (projectId, name) => {
        dispatch(saveSuccess(projectId, name));
        dispatch(setProjectTitle(name));
    },
    onSaveFailure: error => dispatch(saveFailure(error))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveProjectModal);
